import { render, staticRenderFns } from "./text_input.vue?vue&type=template&id=ed83f8a2&"
import script from "./text_input.vue?vue&type=script&lang=js&"
export * from "./text_input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports